import '../../node_modules/flickity/dist/flickity.pkgd.js';


// Initialize flickity
( function() {
	let gals = document.querySelectorAll('[data-flkty]');
	if (! gals.length) return;
	let galOptions = {
		pageDots: false,
		wrapAround: true,
		imagesLoaded: true,
		autoPlay: true
	};
	for (let gal of gals) {
		new Flickity(gal, {
			pageDots: false,
			wrapAround: true,
			imagesLoaded: true,
			autoPlay: true
		});
		let id = gal.id;
		if (!id) continue;
		let nav = document.querySelector(`[data-flkty-id="${id}"]`);
		if (nav) {
			new Flickity( nav, {
				asNavFor: gal,
				pageDots: false,
				prevNextButtons: false,
				wrapAround: true,
				imagesLoaded: true,
				watchCSS: true,
			});
		}
	}
} )();
